import TextInput from "@client/controls/Inputs/TextInput/component";
import * as React from "react";

interface SearchInputProps {
  close: () => void;
  onEnter: (e: React.KeyboardEvent) => void;
  onChange: (text: string) => any;
  value: string;
}

// Note: don't call "close" on onBlur
const SearchInput = (props: SearchInputProps) => (
  <TextInput
    placeholder="Type and press enter..."
    autoFocus
    autoComplete="off"
    onChange={props.onChange}
    onEnter={props.onEnter}
    onEscape={props.close}
    value={props.value}
  />
);

export default SearchInput;
